import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.Plumbing;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "Plumbing.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "Plumbing.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "Plumbing.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/PlumbingGame/scenes/IntroductionScene.ts